export default __webpack_public_path__ + "69757909222686837ea7af0456f0bb0d.png";